export type RunnerUiSnapshot = {
  hudVisible: boolean;
  pauseVisible: boolean;
  gameOverVisible: boolean;
  stageSelectVisible: boolean;
  score: number;
  lives: number;
  selectedStageId: string;
};

const initial: RunnerUiSnapshot = {
  hudVisible: false,
  pauseVisible: false,
  gameOverVisible: false,
  stageSelectVisible: false,
  score: 0,
  lives: 3,
  selectedStageId: 'almaty',
};

let snapshot: RunnerUiSnapshot = { ...initial };
const listeners = new Set<() => void>();

function same(a: RunnerUiSnapshot, b: RunnerUiSnapshot): boolean {
  return (
    a.hudVisible === b.hudVisible &&
    a.pauseVisible === b.pauseVisible &&
    a.gameOverVisible === b.gameOverVisible &&
    a.stageSelectVisible === b.stageSelectVisible &&
    a.score === b.score &&
    a.lives === b.lives &&
    a.selectedStageId === b.selectedStageId
  );
}

export function getRunnerUiSnapshot(): RunnerUiSnapshot {
  return snapshot;
}

export function subscribeRunnerUi(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => listeners.delete(onStoreChange);
}

export function setRunnerUiSnapshot(next: RunnerUiSnapshot): void {
  if (same(snapshot, next)) return;
  snapshot = { ...next };
  listeners.forEach((l) => l());
}

export function patchRunnerUi(patch: Partial<RunnerUiSnapshot>): void {
  setRunnerUiSnapshot({ ...snapshot, ...patch });
}

export function resetRunnerUi(): void {
  setRunnerUiSnapshot({ ...initial });
}
